import { DateTime } from "luxon";

// Very long ago - useful as a fallback value for minimum date boundaries
export const YEAR_0_AD = DateTime.fromObject({ year: 0 });

// Very far into the future - useful as a fallback value for maximum date boundaries
export const YEAR_5000_AD = DateTime.fromObject({ year: 5000 });
